import { useEffect, useState } from "react";
import {
    ConsultaData, calcularPrecioFinal, RutaProductos, TIPO_CAMBIO, moneda_mostrar,
    renderNumero, porcentaje_igv, decodeNombreProductoURL, RutaLocal
} from '../componentes/funcionesEspeciales'
//import parse from 'html-react-parser'; 
//import './inicio.css'
//import './producto.css'
import { useParams } from 'react-router-dom';
import ImageGallery from "react-image-gallery";
import ProductosRelacionados from "../componentes/ProductosRelacionados";

function Producto({ agregarItemCarro }) {
    const [nombre_del_producto, setNombreProducto] = useState("")
    const [producto, setProducto] = useState({
        id: 0,
        art_descripcion: 'Cargando',
        nombre_marca: 'Cargando',
        especificacion_tecnica: 'Cargando',
    })
    const getProducto = (nombre) => {
        //console.log("preguntando por,", nombre) 
        ConsultaData('?/web/getArticuloNombre/&nombre=' + nombre).then(response => {
            if (response.length > 0) {
                setProducto(response[0])
                setNombreProducto(response[0].art_nombre)
                buscarImagenes(response[0].id)
            }
        })
    }
    const agregarItemCarrito = (producto) => {
        let producto_guardar = {
            id: producto.id,
            nombre: producto.nombre,
            imagen: producto.imagen,
            //precio_venta: calcularPrecioFinal(producto.valor_venta_base, producto.tipo_igv, producto.moneda),
            precio_venta: producto.precio_venta,
            descuento: 0,
            cantidad: 1,
        }
        agregarItemCarro(producto_guardar)
    }
    let [tipo_de_cambio, setTipoCambio] = useState(0)
    let { name } = useParams()
    useEffect(() => {
        //let nombre_del_producto = decodeURI(parametros[1])
        //console.log("quee?",name)
        let nombre_del_producto = decodeNombreProductoURL(name)
        getProducto(nombre_del_producto)
        //tc
        TIPO_CAMBIO().then(response => { setTipoCambio(response[0].tipo_cambio_paralelo) })

        /* const iniciarProducto = async () => { 
             let nombre_del_producto = decodeNombreProductoURL(name)
             setNombreProducto(nombre_del_producto)
             getProducto(nombre_del_producto)
             //tc
             TIPO_CAMBIO().then(response => { setTipoCambio(response[0].tipo_cambio_paralelo) })
         };
         iniciarProducto() */
    }, [])
    //imagenes
    const buscarImagenes = (id_articulo) => {
        //console.log("buscare", id_articulo)
        ConsultaData('?/web/getImagenes/&id=' + id_articulo).then(response => {
            let images = []
            response.map((item) => {
                images.push({
                    original: RutaProductos + item.imagen,
                    thumbnail: RutaProductos + item.imagen,
                    originalHeight: "330px",
                    //originalWidth: "auto",
                    originalWidth: "100%",
                    sizes: "(max-width: 710px) 120px,  (max-width: 991px) 193px,  278px",
                    originalClass: "border border-1 border-dark"
                })
            })
            if (images.length > 0) {
                setImagenes(images)
            }
        })
    }
    const [imagenes, setImagenes] = useState([{
        original: "https://i.imgur.com/m7A8LhG.jpg",//imagen por defecto
        thumbnail: "https://i.imgur.com/m7A8LhG.jpg",
        sizes: "(max-width: 710px) 120px,  (max-width: 991px) 193px,  278px",
        originalHeight: "240px",
        //originalWidth: "auto",
        originalWidth: "140px",
    }])
    const [productosRelacionados, setProductosRelacionados] = useState([])
    return (
        <div className=" py-5 container">
            <div className="row">
                <div className="col-md-5 col-lg-5 col-sm-12">
                    {/* <img className="card-img" src={producto.imagen == "" ? "https://i.imgur.com/m7A8LhG.jpg" : RutaProductos + producto.imagen} alt={nombre_del_producto} /> */}
                    <ImageGallery items={imagenes} thumbnailPosition={"bottom"} showPlayButton={false} showNav={false} showThumbnails={false} showFullscreenButton={false}
                        renderLeftNav={(onClick, disabled) => (
                            <button
                                type="button" className="image-gallery-icon image-gallery-left-nav" disabled={disabled}
                                onClick={onClick} aria-label="Anterior Imagen">
                                <span className="fw-bold fs-1">{"<"}</span>
                            </button>
                        )}
                        renderRightNav={(onClick, disabled) => (
                            <button
                                type="button" className="image-gallery-icon image-gallery-right-nav" disabled={disabled}
                                onClick={onClick} aria-label="Siguiente Imagen">
                                <span className="fw-bold fs-1">{">"}</span>
                            </button>
                        )}
                    />
                </div>
                <div className="col-md-7 col-sm-12 col-lg-7">
                    <h1 className="product-name">{nombre_del_producto}</h1>
                    <h2 className="product-brand">
                        <a href={RutaLocal + "marca/" + producto.nombre_marca}>{producto.nombre_marca}</a>
                    </h2>
                    <div className="product-description">{(producto.art_descripcion)}</div>
                    <p className="product-price">
                        {moneda_mostrar}
                        {renderNumero(producto.precio_venta)}
                    </p>
                    {/* <p className="product-stock">
                        En stock: {parseInt(producto.stock_total)} unidades
                    </p> */}
                    <button className="btn btn-primary btn-comprar" type="button" onClick={(e) => agregarItemCarrito(producto)}>Agregar al carrito</button>
                </div>
            </div>
            <hr />
            {/* {JSON.stringify(producto)} */}
            <h3>Puedes acompañar este producto con</h3>
            <div>
                <ProductosRelacionados articulo={producto.id} agregarItemCarro={agregarItemCarro} />
            </div>
        </div>
    );
}

export default Producto;
